const API = "https://jm.komerzy.com/backend/?url=auditoriaapi";

const getToken = () => localStorage.getItem("token");

export const getAuditoria = async () => {
  try {
    const res = await fetch(`${API}&action=listar`, {
      headers: {
        Authorization: `Bearer ${getToken()}`
      }
    });

    if (!res.ok) {
      throw new Error(`Error en el servidor: ${res.status}`);
    }

    const text = await res.text();
    if (!text) throw new Error("La respuesta del servidor está vacía");

    const json = JSON.parse(text);

    return json.data;

  } catch (error) {
    console.error("Error en getAuditoria:", error);
    return [];
  }
};
